













import { Component, Vue } from "vue-property-decorator";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useInterestRateStore } from "@/employer/store/interestRate";
import { InterestRateTableItem } from "@/shared/types";
import FeeSchedules from "@/shared/components/FeeSchedules.vue";

@Component({
  components: {
    GenericLoadingSpinner,
    FeeSchedules
  }
})
export default class HsaBankFeeScheduleAndInterestRatesInfo extends Vue {
  interestRateStore = useInterestRateStore();

  mounted (): void {
    if (this.interestRateStore.isUninitialized) {
      this.interestRateStore.loadInterestRates();
    }
  }

  get isLoading (): boolean {
    return this.interestRateStore.isLoading;
  }

  get interestRateTableFields () {
    return [
      { key: "balance", label: "Balance", thClass: "col-7 col-md-5", tdClass: "col-7 col-md-5" },
      { key: "interestRate", label: "Interest Rate" }
    ];
  }

  get interestRates (): InterestRateTableItem[] {
    if (!this.interestRateStore.interestRates ||
      !this.interestRateStore.interestRates.length) {
      return [];
    }
    return this.interestRateStore.getInterestRatesAsTableData;
  }
}
